export const ui = {
  en: {
    navServices: "Services",
    navApproach: "Our approach",
    navWork: "Selected work",
    navEstimate: "Estimate",
    ownerAccess: "Owner access",
    location: "Bensalem, PA",
    scroll: "Scroll to explore",
    servicesEyebrow: "01 / What we do",
    servicesTitle: "The finish is only as good as the work beneath it.",
    servicesIntro: "From surface repair to complete home improvements, every scope is handled with the same patient eye for line, material and fit.",
    approachEyebrow: "02 / How we work",
    approachTitle: "A clear plan. A careful hand. A space that feels like yours.",
    workEyebrow: "03 / Completed work",
    workTitle: "Craft leaves a lasting trace.",
    workIntro: "Thirteen supplied works showing stonework, tile, stucco, remodeling and exterior finishing in the field.",
    estimateEyebrow: "04 / Start a conversation",
    estimateTitle: "Tell us what needs to change.",
    estimateIntro: "Share the outline of your project. We will follow up in English or Spanish with the next useful step.",
    estimatorTitle: "60-second planning range",
    estimatorIntro: "Use this to frame the conversation—not as a final bid.",
    projectType: "Project type",
    squareFeet: "Approximate square feet",
    rangeLabel: "Planning range",
    contactTitle: "Request a free estimate",
    name: "Your name",
    phone: "Phone number",
    email: "Email (optional)",
    message: "What are you planning?",
    send: "Send request",
    sent: "Request received",
    sentBody: "Thank you. Vincent's team will reach out soon.",
    sendError: "We could not send that yet. Please call us directly.",
    directLine: "Prefer to talk now?",
    address: "Visit / write to us",
    areas: "Areas we serve",
    admin: "Admin",
    footerLine: "Built on quality. Driven by trust.",
    selectProject: "Choose a project",
    projectKitchen: "Kitchen / bath",
    projectAddition: "Addition / new space",
    projectExterior: "Exterior / stonework",
    projectFull: "Complete home improvement",
    estimateNote: "The range updates as you describe the work.",
  },
  es: {
    navServices: "Servicios",
    navApproach: "Nuestro método",
    navWork: "Trabajo elegido",
    navEstimate: "Presupuesto",
    ownerAccess: "Acceso del dueño",
    location: "Bensalem, PA",
    scroll: "Desplazar para explorar",
    servicesEyebrow: "01 / Lo que hacemos",
    servicesTitle: "El acabado solo es tan bueno como el trabajo que lleva debajo.",
    servicesIntro: "Desde reparar una superficie hasta mejorar toda la casa, cada proyecto se atiende con el mismo cuidado por las líneas, los materiales y el ajuste.",
    approachEyebrow: "02 / Cómo trabajamos",
    approachTitle: "Un plan claro. Una mano cuidadosa. Un espacio que se siente suyo.",
    workEyebrow: "03 / Trabajo realizado",
    workTitle: "El oficio deja una huella duradera.",
    workIntro: "Trece trabajos suministrados que muestran piedra, cerámica, estuco, remodelación y acabados exteriores realizados en obra.",
    estimateEyebrow: "04 / Empecemos la conversación",
    estimateTitle: "Cuéntenos qué necesita cambiar.",
    estimateIntro: "Comparta el resumen de su proyecto. Le responderemos en inglés o español con el siguiente paso útil.",
    estimatorTitle: "Rango de planificación en 60 segundos",
    estimatorIntro: "Úselo para iniciar la conversación, no como presupuesto final.",
    projectType: "Tipo de proyecto",
    squareFeet: "Pies cuadrados aproximados",
    rangeLabel: "Rango de planificación",
    contactTitle: "Solicite un presupuesto gratis",
    name: "Su nombre",
    phone: "Número de teléfono",
    email: "Correo electrónico (opcional)",
    message: "¿Qué está planeando?",
    send: "Enviar solicitud",
    sent: "Solicitud recibida",
    sentBody: "Gracias. El equipo de Vincent se comunicará pronto.",
    sendError: "No pudimos enviarlo. Llámenos directamente, por favor.",
    directLine: "¿Prefiere hablar ahora?",
    address: "Visítenos / escríbanos",
    areas: "Áreas de trabajo",
    admin: "Administración",
    footerLine: "Construido con calidad. Impulsado por confianza.",
    selectProject: "Elija un proyecto",
    projectKitchen: "Cocina / baño",
    projectAddition: "Ampliación / espacio nuevo",
    projectExterior: "Exterior / piedra",
    projectFull: "Mejora completa del hogar",
    estimateNote: "El rango cambia mientras describe el trabajo.",
  },
};
